import type { ITimestamps } from '../model/timestamps';

interface IProps {
  timestamps?: ITimestamps;
  date: string | null;
}

export const getAvailableTimes = ({ timestamps = {}, date }: IProps) => {
  const availableTimes: Date[] = [];

  if (date && timestamps?.[date]) {
    for (const time in timestamps[date]) {
      const dateTime = new Date(`${date} ${time}`);

      availableTimes.push(dateTime);
    }
  }

  return availableTimes;
};
